/**
 * done
 */
import React from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import cx from 'classnames';
import { genFormRangeItemStyle } from "./styles";
import { RecursionField, useFieldSchema } from '@formily/react';
export var FormRangeItem = wrapReactionHook(function (props) {
  var children = props.children;
  var prefix = 'form-range-item';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genFormRangeItemStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var schema = useFieldSchema();
  var len = Object.keys(schema.properties || {}).length;
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(prefix, hashId)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-label"), hashId)
  }, schema.title), /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-content"), hashId)
  }, schema.mapProperties(function (item, key, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: cx("".concat(prefix, "-range-item"), hashId),
      key: key
    }, /*#__PURE__*/React.createElement(RecursionField, {
      schema: item,
      name: item.name,
      key: idx
    })), idx < len - 1 ? /*#__PURE__*/React.createElement("div", {
      className: cx("".concat(prefix, "-delimiter"), hashId)
    }, "~") : null);
  }))));
});